var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag tooltip",class:_vm.getStatus(_vm.item),attrs:{"data-tooltip":_vm.item.marker_name}},[_c('strong',[_vm._v(_vm._s(_vm.item.marker_code))])])}
var staticRenderFns = []

export { render, staticRenderFns }